var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"logo-ctr"},[_c('div',{ref:"appTitle",staticClass:"app-title"},[_vm._v("Parallel")])])}
var staticRenderFns = []

export { render, staticRenderFns }